import http from './http';

/// Koku
export function getKoku() {
    return http.get(`/koku`);
}

export function getKokuDetail(id) {
    return http.get(`/koku/detail/${id}`);
}

export function createKoku(data) {
    return http.post(`/koku/create`, data);
}

export function updateKoku(id, data) {
    return http.put(`/koku/update/${id}`, data);
}

export function deleteKoku(id) {
    return http.delete(`/koku/delete/${id}`);
}
